import { Component, Input, OnInit } from '@angular/core';
import { SmallProfileInfo } from 'src/app/core/interfaces/user.model';
import { AccountService } from 'src/app/core/services/account.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-small-profile-item',
  templateUrl: './small-profile-item.component.html',
  styleUrls: ['./small-profile-item.component.scss']
})
export class SmallProfileItemComponent implements OnInit {

  @Input() id: number;

  info: SmallProfileInfo;

  constructor(private accountService: AccountService,) { }

  ngOnInit(): void {
    this.cargarDatos();
  }

  cargarDatos() {
    this.accountService.getSmallProfileInfo(this.id).subscribe((res) => {
      this.info = res;
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      }
    );
  }

}
